// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/connector/v2/resource.proto" (package "c1.connector.v2", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Struct } from "../../../google/protobuf/struct";
import { Any } from "../../../google/protobuf/any";
/**
 * @generated from protobuf message c1.connector.v2.ResourceType
 */
export interface ResourceType {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf field: repeated c1.connector.v2.ResourceType.Trait traits = 3;
     */
    traits: ResourceType_Trait[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 4;
     */
    annotations: Any[];
    /**
     * @generated from protobuf field: string description = 5;
     */
    description: string;
    /**
     * @generated from protobuf field: bool sourced_externally = 6;
     */
    sourcedExternally: boolean;
}
/**
 * @generated from protobuf enum c1.connector.v2.ResourceType.Trait
 */
export enum ResourceType_Trait {
    /**
     * @generated from protobuf enum value: TRAIT_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TRAIT_USER = 1;
     */
    USER = 1,
    /**
     * @generated from protobuf enum value: TRAIT_GROUP = 2;
     */
    GROUP = 2,
    /**
     * @generated from protobuf enum value: TRAIT_ROLE = 3;
     */
    ROLE = 3,
    /**
     * @generated from protobuf enum value: TRAIT_APP = 4;
     */
    APP = 4,
    /**
     * @generated from protobuf enum value: TRAIT_SECRET = 5;
     */
    SECRET = 5,
    /**
     * @generated from protobuf enum value: TRAIT_SECURITY_INSIGHT = 6;
     */
    SECURITY_INSIGHT = 6
}
/**
 * @generated from protobuf message c1.connector.v2.ResourceTypesServiceListResourceTypesRequest
 */
export interface ResourceTypesServiceListResourceTypesRequest {
    /**
     * @generated from protobuf field: c1.connector.v2.Resource parent = 1;
     */
    parent?: Resource;
    /**
     * @generated from protobuf field: uint32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 4;
     */
    annotations: Any[];
    /**
     * @generated from protobuf field: string active_sync_id = 5;
     */
    activeSyncId: string;
}
/**
 * @generated from protobuf message c1.connector.v2.ResourceTypesServiceListResourceTypesResponse
 */
export interface ResourceTypesServiceListResourceTypesResponse {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.ResourceType list = 1;
     */
    list: ResourceType[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 3;
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.CreateResourceRequest
 */
export interface CreateResourceRequest {
    /**
     * @generated from protobuf field: c1.connector.v2.Resource resource = 1;
     */
    resource?: Resource;
}
/**
 * @generated from protobuf message c1.connector.v2.CreateResourceResponse
 */
export interface CreateResourceResponse {
    /**
     * @generated from protobuf field: c1.connector.v2.Resource created = 1;
     */
    created?: Resource;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 2;
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.DeleteResourceRequest
 */
export interface DeleteResourceRequest {
    /**
     * @generated from protobuf field: c1.connector.v2.ResourceId resource_id = 1;
     */
    resourceId?: ResourceId;
    /**
     * @generated from protobuf field: c1.connector.v2.ResourceId parent_resource_id = 2;
     */
    parentResourceId?: ResourceId;
}
/**
 * @generated from protobuf message c1.connector.v2.DeleteResourceResponse
 */
export interface DeleteResourceResponse {
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 1;
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.DeleteResourceV2Request
 */
export interface DeleteResourceV2Request {
    /**
     * @generated from protobuf field: c1.connector.v2.ResourceId resource_id = 1;
     */
    resourceId?: ResourceId;
    /**
     * @generated from protobuf field: c1.connector.v2.ResourceId parent_resource_id = 2;
     */
    parentResourceId?: ResourceId;
}
/**
 * @generated from protobuf message c1.connector.v2.DeleteResourceV2Response
 */
export interface DeleteResourceV2Response {
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 1;
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.RotateCredentialRequest
 */
export interface RotateCredentialRequest {
    /**
     * @generated from protobuf field: c1.connector.v2.ResourceId resource_id = 1;
     */
    resourceId?: ResourceId;
    /**
     * @generated from protobuf field: c1.connector.v2.CredentialOptions credential_options = 2;
     */
    credentialOptions?: CredentialOptions;
    /**
     * @generated from protobuf field: repeated c1.connector.v2.EncryptionConfig encryption_configs = 3;
     */
    encryptionConfigs: EncryptionConfig[];
}
/**
 * @generated from protobuf message c1.connector.v2.RotateCredentialResponse
 */
export interface RotateCredentialResponse {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.EncryptedData encrypted_data = 1;
     */
    encryptedData: EncryptedData[];
    /**
     * @generated from protobuf field: c1.connector.v2.ResourceId resource_id = 2;
     */
    resourceId?: ResourceId;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 3;
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.AccountInfo
 */
export interface AccountInfo {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.AccountInfo.Email emails = 1;
     */
    emails: AccountInfo_Email[];
    /**
     * The user's login
     *
     * @generated from protobuf field: string login = 2;
     */
    login: string;
    /**
     * Any additional login aliases for the user
     *
     * @generated from protobuf field: repeated string login_aliases = 3;
     */
    loginAliases: string[];
    /**
     * @generated from protobuf field: google.protobuf.Struct profile = 4;
     */
    profile?: Struct;
}
/**
 * @generated from protobuf message c1.connector.v2.AccountInfo.Email
 */
export interface AccountInfo_Email {
    /**
     * @generated from protobuf field: string address = 1;
     */
    address: string;
    /**
     * Indicates if this is the user's primary email. Only one entry can be marked as primary.
     *
     * @generated from protobuf field: bool is_primary = 2;
     */
    isPrimary: boolean;
}
/**
 * @generated from protobuf message c1.connector.v2.CredentialOptions
 */
export interface CredentialOptions {
    /**
     * @generated from protobuf oneof: options
     */
    options: {
        oneofKind: "randomPassword";
        /**
         * @generated from protobuf field: c1.connector.v2.CredentialOptions.RandomPassword random_password = 100;
         */
        randomPassword: CredentialOptions_RandomPassword;
    } | {
        oneofKind: "noPassword";
        /**
         * @generated from protobuf field: c1.connector.v2.CredentialOptions.NoPassword no_password = 101;
         */
        noPassword: CredentialOptions_NoPassword;
    } | {
        oneofKind: "sso";
        /**
         * @generated from protobuf field: c1.connector.v2.CredentialOptions.SSO sso = 102;
         */
        sso: CredentialOptions_SSO;
    } | {
        oneofKind: "encryptedPassword";
        /**
         * @generated from protobuf field: c1.connector.v2.CredentialOptions.EncryptedPassword encrypted_password = 103;
         */
        encryptedPassword: CredentialOptions_EncryptedPassword;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: bool force_change_at_next_login = 1;
     */
    forceChangeAtNextLogin: boolean;
}
/**
 * @generated from protobuf message c1.connector.v2.CredentialOptions.RandomPassword
 */
export interface CredentialOptions_RandomPassword {
    /**
     * @generated from protobuf field: int64 length = 1;
     */
    length: number;
    /**
     * @generated from protobuf field: repeated c1.connector.v2.PasswordConstraint constraints = 2;
     */
    constraints: PasswordConstraint[];
}
/**
 * @generated from protobuf message c1.connector.v2.CredentialOptions.NoPassword
 */
export interface CredentialOptions_NoPassword {
}
/**
 * @generated from protobuf message c1.connector.v2.CredentialOptions.SSO
 */
export interface CredentialOptions_SSO {
    /**
     * @generated from protobuf field: string sso_provider = 1;
     */
    ssoProvider: string;
}
/**
 * @generated from protobuf message c1.connector.v2.CredentialOptions.EncryptedPassword
 */
export interface CredentialOptions_EncryptedPassword {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.EncryptedData encrypted_passwords = 1;
     */
    encryptedPasswords: EncryptedData[];
}
/**
 * Do not use this in any RPC or any message that is in an RPC.
 *
 * @generated from protobuf message c1.connector.v2.LocalCredentialOptions
 */
export interface LocalCredentialOptions {
    /**
     * @generated from protobuf oneof: options
     */
    options: {
        oneofKind: "randomPassword";
        /**
         * @generated from protobuf field: c1.connector.v2.LocalCredentialOptions.RandomPassword random_password = 100;
         */
        randomPassword: LocalCredentialOptions_RandomPassword;
    } | {
        oneofKind: "noPassword";
        /**
         * @generated from protobuf field: c1.connector.v2.LocalCredentialOptions.NoPassword no_password = 101;
         */
        noPassword: LocalCredentialOptions_NoPassword;
    } | {
        oneofKind: "sso";
        /**
         * @generated from protobuf field: c1.connector.v2.LocalCredentialOptions.SSO sso = 102;
         */
        sso: LocalCredentialOptions_SSO;
    } | {
        oneofKind: "plaintextPassword";
        /**
         * @generated from protobuf field: c1.connector.v2.LocalCredentialOptions.PlaintextPassword plaintext_password = 103;
         */
        plaintextPassword: LocalCredentialOptions_PlaintextPassword;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: bool force_change_at_next_login = 1;
     */
    forceChangeAtNextLogin: boolean;
}
/**
 * @generated from protobuf message c1.connector.v2.LocalCredentialOptions.RandomPassword
 */
export interface LocalCredentialOptions_RandomPassword {
    /**
     * @generated from protobuf field: int64 length = 1;
     */
    length: number;
    /**
     * @generated from protobuf field: repeated c1.connector.v2.PasswordConstraint constraints = 2;
     */
    constraints: PasswordConstraint[];
}
/**
 * @generated from protobuf message c1.connector.v2.LocalCredentialOptions.NoPassword
 */
export interface LocalCredentialOptions_NoPassword {
}
/**
 * @generated from protobuf message c1.connector.v2.LocalCredentialOptions.SSO
 */
export interface LocalCredentialOptions_SSO {
    /**
     * @generated from protobuf field: string sso_provider = 1;
     */
    ssoProvider: string;
}
/**
 * @generated from protobuf message c1.connector.v2.LocalCredentialOptions.PlaintextPassword
 */
export interface LocalCredentialOptions_PlaintextPassword {
    /**
     * @generated from protobuf field: string plaintext_password = 1;
     */
    plaintextPassword: string;
}
/**
 * @generated from protobuf message c1.connector.v2.PasswordConstraint
 */
export interface PasswordConstraint {
    /**
     * @generated from protobuf field: string char_set = 1;
     */
    charSet: string;
    /**
     * @generated from protobuf field: uint32 min_count = 2;
     */
    minCount: number;
}
/**
 * @generated from protobuf message c1.connector.v2.CreateAccountRequest
 */
export interface CreateAccountRequest {
    /**
     * @generated from protobuf field: c1.connector.v2.AccountInfo account_info = 1;
     */
    accountInfo?: AccountInfo;
    /**
     * @generated from protobuf field: c1.connector.v2.CredentialOptions credential_options = 2;
     */
    credentialOptions?: CredentialOptions;
    /**
     * @generated from protobuf field: repeated c1.connector.v2.EncryptionConfig encryption_configs = 3;
     */
    encryptionConfigs: EncryptionConfig[];
    /**
     * @generated from protobuf field: string resource_type_id = 4;
     */
    resourceTypeId: string;
}
/**
 * @generated from protobuf message c1.connector.v2.CreateAccountResponse
 */
export interface CreateAccountResponse {
    /**
     * @generated from protobuf oneof: result
     */
    result: {
        oneofKind: "success";
        /**
         * @generated from protobuf field: c1.connector.v2.CreateAccountResponse.SuccessResult success = 100;
         */
        success: CreateAccountResponse_SuccessResult;
    } | {
        oneofKind: "actionRequired";
        /**
         * @generated from protobuf field: c1.connector.v2.CreateAccountResponse.ActionRequiredResult action_required = 101;
         */
        actionRequired: CreateAccountResponse_ActionRequiredResult;
    } | {
        oneofKind: "alreadyExists";
        /**
         * @generated from protobuf field: c1.connector.v2.CreateAccountResponse.AlreadyExistsResult already_exists = 102;
         */
        alreadyExists: CreateAccountResponse_AlreadyExistsResult;
    } | {
        oneofKind: "inProgress";
        /**
         * @generated from protobuf field: c1.connector.v2.CreateAccountResponse.InProgressResult in_progress = 103;
         */
        inProgress: CreateAccountResponse_InProgressResult;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: repeated c1.connector.v2.EncryptedData encrypted_data = 2;
     */
    encryptedData: EncryptedData[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 3;
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.CreateAccountResponse.SuccessResult
 */
export interface CreateAccountResponse_SuccessResult {
    /**
     * @generated from protobuf field: c1.connector.v2.Resource resource = 1;
     */
    resource?: Resource;
    /**
     * @generated from protobuf field: bool is_create_account_result = 2;
     */
    isCreateAccountResult: boolean;
}
/**
 * @generated from protobuf message c1.connector.v2.CreateAccountResponse.ActionRequiredResult
 */
export interface CreateAccountResponse_ActionRequiredResult {
    /**
     * @generated from protobuf field: c1.connector.v2.Resource resource = 1;
     */
    resource?: Resource;
    /**
     * @generated from protobuf field: string message = 2;
     */
    message: string;
    /**
     * @generated from protobuf field: bool is_create_account_result = 3;
     */
    isCreateAccountResult: boolean;
}
/**
 * @generated from protobuf message c1.connector.v2.CreateAccountResponse.AlreadyExistsResult
 */
export interface CreateAccountResponse_AlreadyExistsResult {
    /**
     * @generated from protobuf field: c1.connector.v2.Resource resource = 1;
     */
    resource?: Resource;
    /**
     * @generated from protobuf field: bool is_create_account_result = 2;
     */
    isCreateAccountResult: boolean;
}
/**
 * @generated from protobuf message c1.connector.v2.CreateAccountResponse.InProgressResult
 */
export interface CreateAccountResponse_InProgressResult {
    /**
     * @generated from protobuf field: c1.connector.v2.Resource resource = 1;
     */
    resource?: Resource; // Optional.
    /**
     * @generated from protobuf field: bool is_create_account_result = 2;
     */
    isCreateAccountResult: boolean;
}
/**
 * @generated from protobuf message c1.connector.v2.EncryptedData
 */
export interface EncryptedData {
    /**
     * @generated from protobuf field: string provider = 1;
     */
    provider: string;
    /**
     * @deprecated
     * @generated from protobuf field: string key_id = 2 [deprecated = true];
     */
    keyId: string;
    /**
     * @generated from protobuf field: string name = 3;
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 4;
     */
    description: string;
    /**
     * @generated from protobuf field: string schema = 5;
     */
    schema: string; // optional
    /**
     * @generated from protobuf field: bytes encrypted_bytes = 6;
     */
    encryptedBytes: Uint8Array; // if 'schema' is set, this should be JSON.
    /**
     * @generated from protobuf field: repeated string key_ids = 7;
     */
    keyIds: string[];
}
/**
 * @generated from protobuf message c1.connector.v2.PlaintextData
 */
export interface PlaintextData {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * @generated from protobuf field: string schema = 3;
     */
    schema: string; // optional
    /**
     * @generated from protobuf field: bytes bytes = 4;
     */
    bytes: Uint8Array; // if 'schema' is set, this should be JSON.
}
/**
 * @generated from protobuf message c1.connector.v2.EncryptionConfig
 */
export interface EncryptionConfig {
    /**
     * @generated from protobuf field: c1.connector.v2.Resource principal = 1;
     */
    principal?: Resource;
    /**
     * @generated from protobuf field: string provider = 2;
     */
    provider: string;
    /**
     * @generated from protobuf field: string key_id = 3;
     */
    keyId: string;
    /**
     * @generated from protobuf oneof: config
     */
    config: {
        oneofKind: "jwkPublicKeyConfig";
        /**
         * @generated from protobuf field: c1.connector.v2.EncryptionConfig.JWKPublicKeyConfig jwk_public_key_config = 100;
         */
        jwkPublicKeyConfig: EncryptionConfig_JWKPublicKeyConfig;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.connector.v2.EncryptionConfig.JWKPublicKeyConfig
 */
export interface EncryptionConfig_JWKPublicKeyConfig {
    /**
     * @generated from protobuf field: bytes pub_key = 1;
     */
    pubKey: Uint8Array;
}
/**
 * @generated from protobuf message c1.connector.v2.ResourceId
 */
export interface ResourceId {
    /**
     * @generated from protobuf field: string resource_type = 1;
     */
    resourceType: string;
    /**
     * @generated from protobuf field: string resource = 2;
     */
    resource: string;
    /**
     * @generated from protobuf field: bool baton_resource = 3;
     */
    batonResource: boolean;
}
/**
 * @generated from protobuf message c1.connector.v2.Resource
 */
export interface Resource {
    /**
     * @generated from protobuf field: c1.connector.v2.ResourceId id = 1;
     */
    id?: ResourceId;
    /**
     * @generated from protobuf field: c1.connector.v2.ResourceId parent_resource_id = 2;
     */
    parentResourceId?: ResourceId;
    /**
     * @generated from protobuf field: string display_name = 3;
     */
    displayName: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 4;
     */
    annotations: Any[];
    /**
     * @generated from protobuf field: string description = 5;
     */
    description: string;
    /**
     * @generated from protobuf field: bool baton_resource = 6;
     */
    batonResource: boolean;
    /**
     * @generated from protobuf field: c1.connector.v2.ExternalId external_id = 7;
     */
    externalId?: ExternalId;
    /**
     * @generated from protobuf field: c1.connector.v2.Resource.CreationSource creation_source = 8;
     */
    creationSource: Resource_CreationSource;
}
/**
 * FIXME(mstanbCO): call this something else? Should it just be a bool? Possibly just use an annotation?
 *
 * @generated from protobuf enum c1.connector.v2.Resource.CreationSource
 */
export enum Resource_CreationSource {
    /**
     * @generated from protobuf enum value: CREATION_SOURCE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: CREATION_SOURCE_CONNECTOR_LIST_RESOURCES = 1;
     */
    CONNECTOR_LIST_RESOURCES = 1,
    /**
     * @generated from protobuf enum value: CREATION_SOURCE_CONNECTOR_LIST_GRANTS_PRINCIPAL_JIT = 2;
     */
    CONNECTOR_LIST_GRANTS_PRINCIPAL_JIT = 2
}
/**
 * @generated from protobuf message c1.connector.v2.ResourcesServiceListResourcesRequest
 */
export interface ResourcesServiceListResourcesRequest {
    /**
     * @generated from protobuf field: string resource_type_id = 1;
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: c1.connector.v2.ResourceId parent_resource_id = 2;
     */
    parentResourceId?: ResourceId;
    /**
     * @generated from protobuf field: uint32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 5;
     */
    annotations: Any[];
    /**
     * @generated from protobuf field: string active_sync_id = 6;
     */
    activeSyncId: string;
}
/**
 * @generated from protobuf message c1.connector.v2.ResourcesServiceListResourcesResponse
 */
export interface ResourcesServiceListResourcesResponse {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.Resource list = 1;
     */
    list: Resource[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 3;
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.ResourceGetterServiceGetResourceRequest
 */
export interface ResourceGetterServiceGetResourceRequest {
    /**
     * @generated from protobuf field: c1.connector.v2.ResourceId resource_id = 1;
     */
    resourceId?: ResourceId;
    /**
     * @generated from protobuf field: c1.connector.v2.ResourceId parent_resource_id = 2;
     */
    parentResourceId?: ResourceId;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 3;
     */
    annotations: Any[];
    /**
     * @generated from protobuf field: string active_sync_id = 4;
     */
    activeSyncId: string;
}
/**
 * @generated from protobuf message c1.connector.v2.ResourceGetterServiceGetResourceResponse
 */
export interface ResourceGetterServiceGetResourceResponse {
    /**
     * @generated from protobuf field: c1.connector.v2.Resource resource = 1;
     */
    resource?: Resource;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 2;
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.ExternalId
 */
export interface ExternalId {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string link = 2;
     */
    link: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class ResourceType$Type extends MessageType<ResourceType> {
    constructor() {
        super("c1.connector.v2.ResourceType", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024", ignoreEmpty: true } } } },
            { no: 3, name: "traits", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.connector.v2.ResourceType.Trait", ResourceType_Trait, "TRAIT_"], options: { "validate.rules": { repeated: { unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 4, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 5, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "4096", ignoreEmpty: true } } } },
            { no: 6, name: "sourced_externally", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ResourceType
 */
export const ResourceType = new ResourceType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourceTypesServiceListResourceTypesRequest$Type extends MessageType<ResourceTypesServiceListResourceTypesRequest> {
    constructor() {
        super("c1.connector.v2.ResourceTypesServiceListResourceTypesRequest", [
            { no: 1, name: "parent", kind: "message", T: () => Resource },
            { no: 2, name: "page_size", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "validate.rules": { uint32: { lte: 250, ignoreEmpty: true } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1048576", ignoreEmpty: true } } } },
            { no: 4, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 5, name: "active_sync_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024", ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ResourceTypesServiceListResourceTypesRequest
 */
export const ResourceTypesServiceListResourceTypesRequest = new ResourceTypesServiceListResourceTypesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourceTypesServiceListResourceTypesResponse$Type extends MessageType<ResourceTypesServiceListResourceTypesResponse> {
    constructor() {
        super("c1.connector.v2.ResourceTypesServiceListResourceTypesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ResourceType },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1048576", ignoreEmpty: true } } } },
            { no: 3, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ResourceTypesServiceListResourceTypesResponse
 */
export const ResourceTypesServiceListResourceTypesResponse = new ResourceTypesServiceListResourceTypesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateResourceRequest$Type extends MessageType<CreateResourceRequest> {
    constructor() {
        super("c1.connector.v2.CreateResourceRequest", [
            { no: 1, name: "resource", kind: "message", T: () => Resource }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CreateResourceRequest
 */
export const CreateResourceRequest = new CreateResourceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateResourceResponse$Type extends MessageType<CreateResourceResponse> {
    constructor() {
        super("c1.connector.v2.CreateResourceResponse", [
            { no: 1, name: "created", kind: "message", T: () => Resource },
            { no: 2, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CreateResourceResponse
 */
export const CreateResourceResponse = new CreateResourceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteResourceRequest$Type extends MessageType<DeleteResourceRequest> {
    constructor() {
        super("c1.connector.v2.DeleteResourceRequest", [
            { no: 1, name: "resource_id", kind: "message", T: () => ResourceId },
            { no: 2, name: "parent_resource_id", kind: "message", T: () => ResourceId }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.DeleteResourceRequest
 */
export const DeleteResourceRequest = new DeleteResourceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteResourceResponse$Type extends MessageType<DeleteResourceResponse> {
    constructor() {
        super("c1.connector.v2.DeleteResourceResponse", [
            { no: 1, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.DeleteResourceResponse
 */
export const DeleteResourceResponse = new DeleteResourceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteResourceV2Request$Type extends MessageType<DeleteResourceV2Request> {
    constructor() {
        super("c1.connector.v2.DeleteResourceV2Request", [
            { no: 1, name: "resource_id", kind: "message", T: () => ResourceId },
            { no: 2, name: "parent_resource_id", kind: "message", T: () => ResourceId }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.DeleteResourceV2Request
 */
export const DeleteResourceV2Request = new DeleteResourceV2Request$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteResourceV2Response$Type extends MessageType<DeleteResourceV2Response> {
    constructor() {
        super("c1.connector.v2.DeleteResourceV2Response", [
            { no: 1, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.DeleteResourceV2Response
 */
export const DeleteResourceV2Response = new DeleteResourceV2Response$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RotateCredentialRequest$Type extends MessageType<RotateCredentialRequest> {
    constructor() {
        super("c1.connector.v2.RotateCredentialRequest", [
            { no: 1, name: "resource_id", kind: "message", T: () => ResourceId },
            { no: 2, name: "credential_options", kind: "message", T: () => CredentialOptions },
            { no: 3, name: "encryption_configs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => EncryptionConfig }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.RotateCredentialRequest
 */
export const RotateCredentialRequest = new RotateCredentialRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RotateCredentialResponse$Type extends MessageType<RotateCredentialResponse> {
    constructor() {
        super("c1.connector.v2.RotateCredentialResponse", [
            { no: 1, name: "encrypted_data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => EncryptedData },
            { no: 2, name: "resource_id", kind: "message", T: () => ResourceId },
            { no: 3, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.RotateCredentialResponse
 */
export const RotateCredentialResponse = new RotateCredentialResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountInfo$Type extends MessageType<AccountInfo> {
    constructor() {
        super("c1.connector.v2.AccountInfo", [
            { no: 1, name: "emails", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccountInfo_Email },
            { no: 2, name: "login", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "login_aliases", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "profile", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.AccountInfo
 */
export const AccountInfo = new AccountInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountInfo_Email$Type extends MessageType<AccountInfo_Email> {
    constructor() {
        super("c1.connector.v2.AccountInfo.Email", [
            { no: 1, name: "address", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { email: true } } } },
            { no: 2, name: "is_primary", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.AccountInfo.Email
 */
export const AccountInfo_Email = new AccountInfo_Email$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CredentialOptions$Type extends MessageType<CredentialOptions> {
    constructor() {
        super("c1.connector.v2.CredentialOptions", [
            { no: 100, name: "random_password", kind: "message", oneof: "options", T: () => CredentialOptions_RandomPassword },
            { no: 101, name: "no_password", kind: "message", oneof: "options", T: () => CredentialOptions_NoPassword },
            { no: 102, name: "sso", kind: "message", oneof: "options", T: () => CredentialOptions_SSO },
            { no: 103, name: "encrypted_password", kind: "message", oneof: "options", T: () => CredentialOptions_EncryptedPassword },
            { no: 1, name: "force_change_at_next_login", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CredentialOptions
 */
export const CredentialOptions = new CredentialOptions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CredentialOptions_RandomPassword$Type extends MessageType<CredentialOptions_RandomPassword> {
    constructor() {
        super("c1.connector.v2.CredentialOptions.RandomPassword", [
            { no: 1, name: "length", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/, options: { "validate.rules": { int64: { lte: "64", gte: "8" } } } },
            { no: 2, name: "constraints", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PasswordConstraint }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CredentialOptions.RandomPassword
 */
export const CredentialOptions_RandomPassword = new CredentialOptions_RandomPassword$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CredentialOptions_NoPassword$Type extends MessageType<CredentialOptions_NoPassword> {
    constructor() {
        super("c1.connector.v2.CredentialOptions.NoPassword", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CredentialOptions.NoPassword
 */
export const CredentialOptions_NoPassword = new CredentialOptions_NoPassword$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CredentialOptions_SSO$Type extends MessageType<CredentialOptions_SSO> {
    constructor() {
        super("c1.connector.v2.CredentialOptions.SSO", [
            { no: 1, name: "sso_provider", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CredentialOptions.SSO
 */
export const CredentialOptions_SSO = new CredentialOptions_SSO$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CredentialOptions_EncryptedPassword$Type extends MessageType<CredentialOptions_EncryptedPassword> {
    constructor() {
        super("c1.connector.v2.CredentialOptions.EncryptedPassword", [
            { no: 1, name: "encrypted_passwords", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => EncryptedData, options: { "validate.rules": { repeated: { minItems: "1" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CredentialOptions.EncryptedPassword
 */
export const CredentialOptions_EncryptedPassword = new CredentialOptions_EncryptedPassword$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LocalCredentialOptions$Type extends MessageType<LocalCredentialOptions> {
    constructor() {
        super("c1.connector.v2.LocalCredentialOptions", [
            { no: 100, name: "random_password", kind: "message", oneof: "options", T: () => LocalCredentialOptions_RandomPassword },
            { no: 101, name: "no_password", kind: "message", oneof: "options", T: () => LocalCredentialOptions_NoPassword },
            { no: 102, name: "sso", kind: "message", oneof: "options", T: () => LocalCredentialOptions_SSO },
            { no: 103, name: "plaintext_password", kind: "message", oneof: "options", T: () => LocalCredentialOptions_PlaintextPassword },
            { no: 1, name: "force_change_at_next_login", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.LocalCredentialOptions
 */
export const LocalCredentialOptions = new LocalCredentialOptions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LocalCredentialOptions_RandomPassword$Type extends MessageType<LocalCredentialOptions_RandomPassword> {
    constructor() {
        super("c1.connector.v2.LocalCredentialOptions.RandomPassword", [
            { no: 1, name: "length", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/, options: { "validate.rules": { int64: { lte: "64", gte: "8" } } } },
            { no: 2, name: "constraints", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PasswordConstraint }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.LocalCredentialOptions.RandomPassword
 */
export const LocalCredentialOptions_RandomPassword = new LocalCredentialOptions_RandomPassword$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LocalCredentialOptions_NoPassword$Type extends MessageType<LocalCredentialOptions_NoPassword> {
    constructor() {
        super("c1.connector.v2.LocalCredentialOptions.NoPassword", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.LocalCredentialOptions.NoPassword
 */
export const LocalCredentialOptions_NoPassword = new LocalCredentialOptions_NoPassword$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LocalCredentialOptions_SSO$Type extends MessageType<LocalCredentialOptions_SSO> {
    constructor() {
        super("c1.connector.v2.LocalCredentialOptions.SSO", [
            { no: 1, name: "sso_provider", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.LocalCredentialOptions.SSO
 */
export const LocalCredentialOptions_SSO = new LocalCredentialOptions_SSO$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LocalCredentialOptions_PlaintextPassword$Type extends MessageType<LocalCredentialOptions_PlaintextPassword> {
    constructor() {
        super("c1.connector.v2.LocalCredentialOptions.PlaintextPassword", [
            { no: 1, name: "plaintext_password", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.LocalCredentialOptions.PlaintextPassword
 */
export const LocalCredentialOptions_PlaintextPassword = new LocalCredentialOptions_PlaintextPassword$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordConstraint$Type extends MessageType<PasswordConstraint> {
    constructor() {
        super("c1.connector.v2.PasswordConstraint", [
            { no: 1, name: "char_set", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "min_count", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.PasswordConstraint
 */
export const PasswordConstraint = new PasswordConstraint$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccountRequest$Type extends MessageType<CreateAccountRequest> {
    constructor() {
        super("c1.connector.v2.CreateAccountRequest", [
            { no: 1, name: "account_info", kind: "message", T: () => AccountInfo },
            { no: 2, name: "credential_options", kind: "message", T: () => CredentialOptions },
            { no: 3, name: "encryption_configs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => EncryptionConfig },
            { no: 4, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024", ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CreateAccountRequest
 */
export const CreateAccountRequest = new CreateAccountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccountResponse$Type extends MessageType<CreateAccountResponse> {
    constructor() {
        super("c1.connector.v2.CreateAccountResponse", [
            { no: 100, name: "success", kind: "message", oneof: "result", T: () => CreateAccountResponse_SuccessResult },
            { no: 101, name: "action_required", kind: "message", oneof: "result", T: () => CreateAccountResponse_ActionRequiredResult },
            { no: 102, name: "already_exists", kind: "message", oneof: "result", T: () => CreateAccountResponse_AlreadyExistsResult },
            { no: 103, name: "in_progress", kind: "message", oneof: "result", T: () => CreateAccountResponse_InProgressResult },
            { no: 2, name: "encrypted_data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => EncryptedData },
            { no: 3, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CreateAccountResponse
 */
export const CreateAccountResponse = new CreateAccountResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccountResponse_SuccessResult$Type extends MessageType<CreateAccountResponse_SuccessResult> {
    constructor() {
        super("c1.connector.v2.CreateAccountResponse.SuccessResult", [
            { no: 1, name: "resource", kind: "message", T: () => Resource },
            { no: 2, name: "is_create_account_result", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CreateAccountResponse.SuccessResult
 */
export const CreateAccountResponse_SuccessResult = new CreateAccountResponse_SuccessResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccountResponse_ActionRequiredResult$Type extends MessageType<CreateAccountResponse_ActionRequiredResult> {
    constructor() {
        super("c1.connector.v2.CreateAccountResponse.ActionRequiredResult", [
            { no: 1, name: "resource", kind: "message", T: () => Resource },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "is_create_account_result", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CreateAccountResponse.ActionRequiredResult
 */
export const CreateAccountResponse_ActionRequiredResult = new CreateAccountResponse_ActionRequiredResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccountResponse_AlreadyExistsResult$Type extends MessageType<CreateAccountResponse_AlreadyExistsResult> {
    constructor() {
        super("c1.connector.v2.CreateAccountResponse.AlreadyExistsResult", [
            { no: 1, name: "resource", kind: "message", T: () => Resource },
            { no: 2, name: "is_create_account_result", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CreateAccountResponse.AlreadyExistsResult
 */
export const CreateAccountResponse_AlreadyExistsResult = new CreateAccountResponse_AlreadyExistsResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccountResponse_InProgressResult$Type extends MessageType<CreateAccountResponse_InProgressResult> {
    constructor() {
        super("c1.connector.v2.CreateAccountResponse.InProgressResult", [
            { no: 1, name: "resource", kind: "message", T: () => Resource },
            { no: 2, name: "is_create_account_result", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CreateAccountResponse.InProgressResult
 */
export const CreateAccountResponse_InProgressResult = new CreateAccountResponse_InProgressResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EncryptedData$Type extends MessageType<EncryptedData> {
    constructor() {
        super("c1.connector.v2.EncryptedData", [
            { no: 1, name: "provider", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "key_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "schema", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "encrypted_bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 7, name: "key_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.EncryptedData
 */
export const EncryptedData = new EncryptedData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PlaintextData$Type extends MessageType<PlaintextData> {
    constructor() {
        super("c1.connector.v2.PlaintextData", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "schema", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.PlaintextData
 */
export const PlaintextData = new PlaintextData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EncryptionConfig$Type extends MessageType<EncryptionConfig> {
    constructor() {
        super("c1.connector.v2.EncryptionConfig", [
            { no: 1, name: "principal", kind: "message", T: () => Resource },
            { no: 2, name: "provider", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "key_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "jwk_public_key_config", kind: "message", oneof: "config", T: () => EncryptionConfig_JWKPublicKeyConfig }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.EncryptionConfig
 */
export const EncryptionConfig = new EncryptionConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EncryptionConfig_JWKPublicKeyConfig$Type extends MessageType<EncryptionConfig_JWKPublicKeyConfig> {
    constructor() {
        super("c1.connector.v2.EncryptionConfig.JWKPublicKeyConfig", [
            { no: 1, name: "pub_key", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.EncryptionConfig.JWKPublicKeyConfig
 */
export const EncryptionConfig_JWKPublicKeyConfig = new EncryptionConfig_JWKPublicKeyConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourceId$Type extends MessageType<ResourceId> {
    constructor() {
        super("c1.connector.v2.ResourceId", [
            { no: 1, name: "resource_type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 2, name: "resource", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 3, name: "baton_resource", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ResourceId
 */
export const ResourceId = new ResourceId$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Resource$Type extends MessageType<Resource> {
    constructor() {
        super("c1.connector.v2.Resource", [
            { no: 1, name: "id", kind: "message", T: () => ResourceId },
            { no: 2, name: "parent_resource_id", kind: "message", T: () => ResourceId },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024", ignoreEmpty: true } } } },
            { no: 4, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 5, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "2048", ignoreEmpty: true } } } },
            { no: 6, name: "baton_resource", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "external_id", kind: "message", T: () => ExternalId },
            { no: 8, name: "creation_source", kind: "enum", T: () => ["c1.connector.v2.Resource.CreationSource", Resource_CreationSource, "CREATION_SOURCE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.Resource
 */
export const Resource = new Resource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourcesServiceListResourcesRequest$Type extends MessageType<ResourcesServiceListResourcesRequest> {
    constructor() {
        super("c1.connector.v2.ResourcesServiceListResourcesRequest", [
            { no: 1, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 2, name: "parent_resource_id", kind: "message", T: () => ResourceId, options: { "validate.rules": { message: { required: false } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "validate.rules": { uint32: { lte: 250, ignoreEmpty: true } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1048576", ignoreEmpty: true } } } },
            { no: 5, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 6, name: "active_sync_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024", ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ResourcesServiceListResourcesRequest
 */
export const ResourcesServiceListResourcesRequest = new ResourcesServiceListResourcesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourcesServiceListResourcesResponse$Type extends MessageType<ResourcesServiceListResourcesResponse> {
    constructor() {
        super("c1.connector.v2.ResourcesServiceListResourcesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Resource },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1048576", ignoreEmpty: true } } } },
            { no: 3, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ResourcesServiceListResourcesResponse
 */
export const ResourcesServiceListResourcesResponse = new ResourcesServiceListResourcesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourceGetterServiceGetResourceRequest$Type extends MessageType<ResourceGetterServiceGetResourceRequest> {
    constructor() {
        super("c1.connector.v2.ResourceGetterServiceGetResourceRequest", [
            { no: 1, name: "resource_id", kind: "message", T: () => ResourceId },
            { no: 2, name: "parent_resource_id", kind: "message", T: () => ResourceId, options: { "validate.rules": { message: { required: false } } } },
            { no: 3, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 4, name: "active_sync_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024", ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ResourceGetterServiceGetResourceRequest
 */
export const ResourceGetterServiceGetResourceRequest = new ResourceGetterServiceGetResourceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourceGetterServiceGetResourceResponse$Type extends MessageType<ResourceGetterServiceGetResourceResponse> {
    constructor() {
        super("c1.connector.v2.ResourceGetterServiceGetResourceResponse", [
            { no: 1, name: "resource", kind: "message", T: () => Resource },
            { no: 2, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ResourceGetterServiceGetResourceResponse
 */
export const ResourceGetterServiceGetResourceResponse = new ResourceGetterServiceGetResourceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalId$Type extends MessageType<ExternalId> {
    constructor() {
        super("c1.connector.v2.ExternalId", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "link", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ExternalId
 */
export const ExternalId = new ExternalId$Type();
/**
 * @generated ServiceType for protobuf service c1.connector.v2.ResourceTypesService
 */
export const ResourceTypesService = new ServiceType("c1.connector.v2.ResourceTypesService", [
    { name: "ListResourceTypes", options: {}, I: ResourceTypesServiceListResourceTypesRequest, O: ResourceTypesServiceListResourceTypesResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.connector.v2.ResourcesService
 */
export const ResourcesService = new ServiceType("c1.connector.v2.ResourcesService", [
    { name: "ListResources", options: {}, I: ResourcesServiceListResourcesRequest, O: ResourcesServiceListResourcesResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.connector.v2.ResourceGetterService
 */
export const ResourceGetterService = new ServiceType("c1.connector.v2.ResourceGetterService", [
    { name: "GetResource", options: {}, I: ResourceGetterServiceGetResourceRequest, O: ResourceGetterServiceGetResourceResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.connector.v2.ResourceManagerService
 */
export const ResourceManagerService = new ServiceType("c1.connector.v2.ResourceManagerService", [
    { name: "CreateResource", options: {}, I: CreateResourceRequest, O: CreateResourceResponse },
    { name: "DeleteResource", options: {}, I: DeleteResourceRequest, O: DeleteResourceResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.connector.v2.ResourceDeleterService
 */
export const ResourceDeleterService = new ServiceType("c1.connector.v2.ResourceDeleterService", [
    { name: "DeleteResourceV2", options: {}, I: DeleteResourceV2Request, O: DeleteResourceV2Response }
]);
/**
 * @generated ServiceType for protobuf service c1.connector.v2.CredentialManagerService
 */
export const CredentialManagerService = new ServiceType("c1.connector.v2.CredentialManagerService", [
    { name: "RotateCredential", options: {}, I: RotateCredentialRequest, O: RotateCredentialResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.connector.v2.AccountManagerService
 */
export const AccountManagerService = new ServiceType("c1.connector.v2.AccountManagerService", [
    { name: "CreateAccount", options: {}, I: CreateAccountRequest, O: CreateAccountResponse }
]);
